import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import MultiSelectBox from '../../../../../features/components/Form/MultiSelectBox'
import FieldRow from '../../../../../features/components/Form/FieldsSection/FieldRow'

import { formatOptionsList } from '../../../../../features/formatters'

import {
  getMediaSubCategoriesIsLoadingSelector,
  mediaSubCategoriesSelector
} from '../../../../../modules/selectors/mediaOrdersProducts'

import { MEDIA_SUB_CATEGORIES } from '../../ControllerInviteCreate/ControllerInviteCreateForm/fields'

const MediaSubCategoriesFieldRow = ({ formik }) => {
  const { t } = useTranslation()

  const { values, errors, setFieldValue } = formik

  const mediaSubCategories = useSelector(mediaSubCategoriesSelector)
  const getMediaSubCategoriesIsLoading = useSelector(getMediaSubCategoriesIsLoadingSelector)

  const formattedMediaSubCategoriesOptions = useMemo(() => {
    return formatOptionsList({
      list: mediaSubCategories,
      valueName: 'id',
      labelName: 'name'
    })
  }, [mediaSubCategories])

  return (
    <FieldRow title={t('Media Sub Categories')}>
      <MultiSelectBox
        isLoading={getMediaSubCategoriesIsLoading}
        placeholder={t('Media Sub Categories')}
        name={MEDIA_SUB_CATEGORIES}
        options={formattedMediaSubCategoriesOptions}
        value={values[MEDIA_SUB_CATEGORIES]}
        setFieldValue={setFieldValue}
        error={errors[MEDIA_SUB_CATEGORIES]}
        touched
      />
    </FieldRow>
  )
}

export default MediaSubCategoriesFieldRow
